import { isLogicGroup } from '../filterQueryFormat/logic/LogicGroup';
import { isOperator } from '../filterQueryFormat/operator/Operator';
export const countMatchingConditions = (parentGroup, requiredFields, filterFamily, isRequiredConditionForEvent) => {
  if (parentGroup && isLogicGroup(parentGroup) && parentGroup.conditions) {
    const matchingConditions = parentGroup.conditions.filter(c => {
      if (!isOperator(c)) {
        return false;
      }
      return c.field && requiredFields.has(c.field.name) || isRequiredConditionForEvent(filterFamily, c);
    }).size;
    return matchingConditions;
  }
  return 0;
};